import React from 'react';
import AnimatedSection from '../../components/ui/AnimatedSection';

const TrustLogos = () => {
  // Generic industries instead of specific business names
  const industries = [
    "Real Estate",
    "Legal Services",
    "Healthcare",
    "E-commerce",
    "SaaS & Tech",
    "Hospitality",
    "FinTech",
    "Professional Services"
  ];

  return (
    <section className="py-10 border-y border-slate-900 bg-slate-950/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold text-slate-500 uppercase tracking-widest mb-8">
          Driving Search Dominance Across NYC's Most Competitive Industries
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
          {industries.map((industry, index) => (
            <AnimatedSection key={index} delay={index * 0.1}>
              <div className="text-lg md:text-xl font-bold text-slate-400 tracking-tight whitespace-nowrap">
                {industry}
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustLogos;